import { Paragraph, YStack, type YStackProps } from 'tamagui';

import { Heading } from '@/components/heading';

// Shared section shell for the Terms of Service and Privacy Policy
// screens (issue #134) -- both are the same structural shape
// (a numbered list of titled sections, each a heading plus one or more
// paragraphs), so this is extracted at the second call site rather than
// duplicated, matching this project's own established precedent
// (BackLink/TextLink's own doc comments cite the same rule).
export function LegalSection({
  title,
  children,
  ...props
}: { title: string; children: React.ReactNode } & YStackProps) {
  return (
    <YStack gap="$2" {...props}>
      <Heading fontSize="$titleS" lineHeight="$titleS" letterSpacing={0}>
        {title}
      </Heading>
      {children}
    </YStack>
  );
}

// Plain paragraph body text for a legal section -- $colorSecondary
// (not $color) matches every other body-copy paragraph in this app
// (Preview, sign-up's own subhead, etc.); legal text is reference
// material a user scans, not the primary content of the screen it
// lives on.
export function LegalParagraph({ children }: { children: React.ReactNode }) {
  return <Paragraph color="$colorSecondary">{children}</Paragraph>;
}
